// extracted by mini-css-extract-plugin
export default {"container":"DropSort_container__sop6G","draggableButtons":"DropSort_draggableButtons__XYUYM","dropBoxes":"DropSort_dropBoxes__qFL-Z"};